module.exports = __webpack_public_path__ + "static/img/zh.80a104a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh.png
// module id = 3Nc4
// module chunks = 0